// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.gradingMatrix").
factory("GradingMatrixCriteria", function gradingMatrixCriteriaService() {
	"use strict";

	function GradingMatrixCriteria(data) {
		var defaults = {
			gradeId: null,
			abilityId: null,
			description: "",
		};

		angular.extend(this, defaults);

		if (data) {
			angular.extend(this, data);
		}
	}

	return GradingMatrixCriteria;
});
